<footer>
  <div class="row">
    <div class="col-12 text-right pr-5">
      <img src="assets/img/carga.gif" class="anim-footer" *ngIf="url !== '/'">
      <img src="assets/img/Sello - Alto contraste Gris - Alta.png ">
    </div>
  </div>
</footer>